module.exports = __webpack_public_path__ + "static/media/Babbit.b4f2296e.PNG";